module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("e83R1"))).then(() => parcelRequire('8rm4T'));